import type { QuestionData } from '../types';

export function localeHasFormTranslationRows(
  questions: QuestionData[],
  languageCode: string,
): boolean {
  for (const q of questions) {
    if (q.translations?.some((t) => t.languageCode === languageCode)) {
      return true;
    }
    if (
      q.options?.some((o) =>
        o.translations?.some((t) => t.languageCode === languageCode),
      )
    ) {
      return true;
    }
  }
  return false;
}
